import {
    DELETE_PRODUCT_MEMBERSHIP,
    DELETE_PRODUCT_MEMBERSHIP_FAILURE,
    DELETE_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const deleteProductMembership = (payload) => {
    return {
        type: DELETE_PRODUCT_MEMBERSHIP,
        payload: payload,
    };
};

export const deleteProductMembershipFailure = (error) => {
    return {
        type: DELETE_PRODUCT_MEMBERSHIP_FAILURE,
        error: error,
    };
};

export const deleteProductMembershipSuccess = (payload) => {
    return {
        type: DELETE_PRODUCT_MEMBERSHIP_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product-memberships/deleteProductMembership.js